import type * as SchemaTypes from '../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ExtendSessionMutationVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


export type ExtendSessionMutation = (
  { __typename: 'Mutation' }
  & { token: SchemaTypes.Mutation['extendSession'] }
);


export const ExtendSessionDocument = /*#__PURE__*/ gql`
    mutation ExtendSession {
  token: extendSession
}
    `;
export type ExtendSessionMutationFn = Apollo.MutationFunction<ExtendSessionMutation, ExtendSessionMutationVariables>;

/**
 * __useExtendSessionMutation__
 *
 * To run a mutation, you first call `useExtendSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtendSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extendSessionMutation, { data, loading, error }] = useExtendSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useExtendSessionMutation(baseOptions?: Apollo.MutationHookOptions<ExtendSessionMutation, ExtendSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExtendSessionMutation, ExtendSessionMutationVariables>(ExtendSessionDocument, options);
      }
export type ExtendSessionMutationHookResult = ReturnType<typeof useExtendSessionMutation>;
export type ExtendSessionMutationResult = Apollo.MutationResult<ExtendSessionMutation>;
export type ExtendSessionMutationOptions = Apollo.BaseMutationOptions<ExtendSessionMutation, ExtendSessionMutationVariables>;